import { reportSentryError } from 'lib/sentry'
import { apiService, createRequestHeadersConfig } from 'shared/api'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'

import { Invoice, Receipt,SaleOrder } from '../../types'

const api = apiService()

export const downloadSaleOrderDocument = (
  currentOrder: SaleOrder,
  salesDocument: Invoice | Receipt,
  token: string
) => {
  const type = salesDocument?.fakturowniaId ? 'invoice' : 'receipt'

  if (type === 'invoice') {
    const axiosConfig = {
      ...createRequestHeadersConfig(token),
      responseType: 'blob'
    }

    // axiosConfig.headers = {
    //   ...axiosConfig.headers,
    //   Accept: 'application/json'
    // }

    api
      .get<Blob>(
        `/sale-orders/${currentOrder.id}/invoice-pdf/${
          salesDocument?.fakturowniaId || ''
        }`,
        axiosConfig
      )
      .then(resp => {
        const pdf = resp.data
        const url = URL.createObjectURL(pdf)
        const link = document.createElement('a')

        link.href = url
        link.setAttribute(
          'download',
          `${salesDocument?.invoiceNumber || ''}.pdf`
        )
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
      .catch(err => {
        toast.error(getApiErrors(err))
        reportSentryError(err, 'Failed to download order document')
      })
  } else if (type === 'receipt') {
    window.open(salesDocument?.ereceiptUrl || '', '_blank')
  }
}
